/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs.js'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'
import * as ConvoDefs from '../../../chat/bsky/convo/defs.defs.js'
import * as ModerationDefs from '../../../com/atproto/moderation/defs.defs.js'
import * as AgeassuranceDefs from '../../../app/bsky/ageassurance/defs.defs.js'
import * as ServerDefs from '../../../com/atproto/server/defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'

const $nsid = 'tools.ozone.moderation.defs'

export { $nsid }

type ModEventView = {
  $type?: 'tools.ozone.moderation.defs#modEventView'
  id: number
  event:
    | l.$Typed<ModEventTakedown>
    | l.$Typed<ModEventReverseTakedown>
    | l.$Typed<ModEventComment>
    | l.$Typed<ModEventReport>
    | l.$Typed<ModEventLabel>
    | l.$Typed<ModEventAcknowledge>
    | l.$Typed<ModEventEscalate>
    | l.$Typed<ModEventMute>
    | l.$Typed<ModEventUnmute>
    | l.$Typed<ModEventMuteReporter>
    | l.$Typed<ModEventUnmuteReporter>
    | l.$Typed<ModEventEmail>
    | l.$Typed<ModEventResolveAppeal>
    | l.$Typed<ModEventDivert>
    | l.$Typed<ModEventTag>
    | l.$Typed<AccountEvent>
    | l.$Typed<IdentityEvent>
    | l.$Typed<RecordEvent>
    | l.$Typed<ModEventPriorityScore>
    | l.$Typed<AgeAssuranceEvent>
    | l.$Typed<AgeAssuranceOverrideEvent>
    | l.$Typed<AgeAssurancePurgeEvent>
    | l.$Typed<RevokeAccountCredentialsEvent>
    | l.$Typed<ScheduleTakedownEvent>
    | l.$Typed<CancelScheduledTakedownEvent>
    | l.Unknown$TypedObject
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.$Typed<ConvoDefs.MessageRef>
    | l.Unknown$TypedObject
  subjectBlobCids: string[]
  createdBy: l.DidString
  createdAt: l.DatetimeString
  creatorHandle?: string
  subjectHandle?: string
  modTool?: ModTool
}

export type { ModEventView }

const modEventView = /*#__PURE__*/ l.typedObject<ModEventView>(
  $nsid,
  'modEventView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    event: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ModEventTakedown>(
          (() => modEventTakedown) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventReverseTakedown>(
          (() => modEventReverseTakedown) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventComment>(
          (() => modEventComment) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventReport>((() => modEventReport) as any),
        /*#__PURE__*/ l.typedRef<ModEventLabel>((() => modEventLabel) as any),
        /*#__PURE__*/ l.typedRef<ModEventAcknowledge>(
          (() => modEventAcknowledge) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventEscalate>(
          (() => modEventEscalate) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventMute>((() => modEventMute) as any),
        /*#__PURE__*/ l.typedRef<ModEventUnmute>((() => modEventUnmute) as any),
        /*#__PURE__*/ l.typedRef<ModEventMuteReporter>(
          (() => modEventMuteReporter) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventUnmuteReporter>(
          (() => modEventUnmuteReporter) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventEmail>((() => modEventEmail) as any),
        /*#__PURE__*/ l.typedRef<ModEventResolveAppeal>(
          (() => modEventResolveAppeal) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventDivert>((() => modEventDivert) as any),
        /*#__PURE__*/ l.typedRef<ModEventTag>((() => modEventTag) as any),
        /*#__PURE__*/ l.typedRef<AccountEvent>((() => accountEvent) as any),
        /*#__PURE__*/ l.typedRef<IdentityEvent>((() => identityEvent) as any),
        /*#__PURE__*/ l.typedRef<RecordEvent>((() => recordEvent) as any),
        /*#__PURE__*/ l.typedRef<ModEventPriorityScore>(
          (() => modEventPriorityScore) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssuranceEvent>(
          (() => ageAssuranceEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssuranceOverrideEvent>(
          (() => ageAssuranceOverrideEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssurancePurgeEvent>(
          (() => ageAssurancePurgeEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<RevokeAccountCredentialsEvent>(
          (() => revokeAccountCredentialsEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<ScheduleTakedownEvent>(
          (() => scheduleTakedownEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<CancelScheduledTakedownEvent>(
          (() => cancelScheduledTakedownEvent) as any,
        ),
      ],
      false,
    ),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.MessageRef>(
          (() => ConvoDefs.messageRef) as any,
        ),
      ],
      false,
    ),
    subjectBlobCids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    creatorHandle: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    subjectHandle: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    modTool: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ModTool>((() => modTool) as any),
    ),
  }),
)

export { modEventView }

type ModEventViewDetail = {
  $type?: 'tools.ozone.moderation.defs#modEventViewDetail'
  id: number
  event:
    | l.$Typed<ModEventTakedown>
    | l.$Typed<ModEventReverseTakedown>
    | l.$Typed<ModEventComment>
    | l.$Typed<ModEventReport>
    | l.$Typed<ModEventLabel>
    | l.$Typed<ModEventAcknowledge>
    | l.$Typed<ModEventEscalate>
    | l.$Typed<ModEventMute>
    | l.$Typed<ModEventUnmute>
    | l.$Typed<ModEventMuteReporter>
    | l.$Typed<ModEventUnmuteReporter>
    | l.$Typed<ModEventEmail>
    | l.$Typed<ModEventResolveAppeal>
    | l.$Typed<ModEventDivert>
    | l.$Typed<ModEventTag>
    | l.$Typed<AccountEvent>
    | l.$Typed<IdentityEvent>
    | l.$Typed<RecordEvent>
    | l.$Typed<ModEventPriorityScore>
    | l.$Typed<AgeAssuranceEvent>
    | l.$Typed<AgeAssuranceOverrideEvent>
    | l.$Typed<AgeAssurancePurgeEvent>
    | l.$Typed<RevokeAccountCredentialsEvent>
    | l.$Typed<ScheduleTakedownEvent>
    | l.$Typed<CancelScheduledTakedownEvent>
    | l.Unknown$TypedObject
  subject:
    | l.$Typed<RepoView>
    | l.$Typed<RepoViewNotFound>
    | l.$Typed<RecordView>
    | l.$Typed<RecordViewNotFound>
    | l.Unknown$TypedObject
  subjectBlobs: BlobView[]
  createdBy: l.DidString
  createdAt: l.DatetimeString
  modTool?: ModTool
}

export type { ModEventViewDetail }

const modEventViewDetail = /*#__PURE__*/ l.typedObject<ModEventViewDetail>(
  $nsid,
  'modEventViewDetail',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    event: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ModEventTakedown>(
          (() => modEventTakedown) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventReverseTakedown>(
          (() => modEventReverseTakedown) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventComment>(
          (() => modEventComment) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventReport>((() => modEventReport) as any),
        /*#__PURE__*/ l.typedRef<ModEventLabel>((() => modEventLabel) as any),
        /*#__PURE__*/ l.typedRef<ModEventAcknowledge>(
          (() => modEventAcknowledge) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventEscalate>(
          (() => modEventEscalate) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventMute>((() => modEventMute) as any),
        /*#__PURE__*/ l.typedRef<ModEventUnmute>((() => modEventUnmute) as any),
        /*#__PURE__*/ l.typedRef<ModEventMuteReporter>(
          (() => modEventMuteReporter) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventUnmuteReporter>(
          (() => modEventUnmuteReporter) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventEmail>((() => modEventEmail) as any),
        /*#__PURE__*/ l.typedRef<ModEventResolveAppeal>(
          (() => modEventResolveAppeal) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventDivert>((() => modEventDivert) as any),
        /*#__PURE__*/ l.typedRef<ModEventTag>((() => modEventTag) as any),
        /*#__PURE__*/ l.typedRef<AccountEvent>((() => accountEvent) as any),
        /*#__PURE__*/ l.typedRef<IdentityEvent>((() => identityEvent) as any),
        /*#__PURE__*/ l.typedRef<RecordEvent>((() => recordEvent) as any),
        /*#__PURE__*/ l.typedRef<ModEventPriorityScore>(
          (() => modEventPriorityScore) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssuranceEvent>(
          (() => ageAssuranceEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssuranceOverrideEvent>(
          (() => ageAssuranceOverrideEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssurancePurgeEvent>(
          (() => ageAssurancePurgeEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<RevokeAccountCredentialsEvent>(
          (() => revokeAccountCredentialsEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<ScheduleTakedownEvent>(
          (() => scheduleTakedownEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<CancelScheduledTakedownEvent>(
          (() => cancelScheduledTakedownEvent) as any,
        ),
      ],
      false,
    ),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<RepoView>((() => repoView) as any),
        /*#__PURE__*/ l.typedRef<RepoViewNotFound>(
          (() => repoViewNotFound) as any,
        ),
        /*#__PURE__*/ l.typedRef<RecordView>((() => recordView) as any),
        /*#__PURE__*/ l.typedRef<RecordViewNotFound>(
          (() => recordViewNotFound) as any,
        ),
      ],
      false,
    ),
    subjectBlobs: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<BlobView>((() => blobView) as any),
    ),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    modTool: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ModTool>((() => modTool) as any),
    ),
  }),
)

export { modEventViewDetail }

type SubjectStatusView = {
  $type?: 'tools.ozone.moderation.defs#subjectStatusView'
  id: number
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.$Typed<ConvoDefs.MessageRef>
    | l.Unknown$TypedObject
  hosting?:
    | l.$Typed<AccountHosting>
    | l.$Typed<RecordHosting>
    | l.Unknown$TypedObject
  subjectBlobCids?: l.CidString[]
  subjectRepoHandle?: string

  /**
   * Timestamp referencing when the last update was made to the moderation status of the subject
   */
  updatedAt: l.DatetimeString

  /**
   * Timestamp referencing the first moderation status impacting event was emitted on the subject
   */
  createdAt: l.DatetimeString
  reviewState: SubjectReviewState

  /**
   * Sticky comment on the subject.
   */
  comment?: string

  /**
   * Numeric value representing the level of priority. Higher score means higher priority.
   */
  priorityScore?: number
  muteUntil?: l.DatetimeString
  muteReportingUntil?: l.DatetimeString
  lastReviewedBy?: l.DidString
  lastReviewedAt?: l.DatetimeString
  lastReportedAt?: l.DatetimeString

  /**
   * Timestamp referencing when the author of the subject appealed a moderation action
   */
  lastAppealedAt?: l.DatetimeString
  takendown?: boolean

  /**
   * True indicates that the a previously taken moderator action was appealed against, by the author of the content. False indicates last appeal was resolved by moderators.
   */
  appealed?: boolean
  suspendUntil?: l.DatetimeString
  tags?: string[]

  /**
   * Statistics related to the account subject
   */
  accountStats?: AccountStats

  /**
   * Statistics related to the record subjects authored by the subject's account
   */
  recordsStats?: RecordsStats

  /**
   * Strike information for the account (account-level only)
   */
  accountStrike?: AccountStrike

  /**
   * Current age assurance state of the subject.
   */
  ageAssuranceState?:
    | 'pending'
    | 'assured'
    | 'unknown'
    | 'reset'
    | 'blocked'
    | l.UnknownString

  /**
   * Whether or not the last successful update to age assurance was made by the user or admin.
   */
  ageAssuranceUpdatedBy?: 'admin' | 'user' | l.UnknownString
}

export type { SubjectStatusView }

const subjectStatusView = /*#__PURE__*/ l.typedObject<SubjectStatusView>(
  $nsid,
  'subjectStatusView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.MessageRef>(
          (() => ConvoDefs.messageRef) as any,
        ),
      ],
      false,
    ),
    hosting: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<AccountHosting>(
            (() => accountHosting) as any,
          ),
          /*#__PURE__*/ l.typedRef<RecordHosting>((() => recordHosting) as any),
        ],
        false,
      ),
    ),
    subjectBlobCids: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'cid' })),
    ),
    subjectRepoHandle: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    reviewState: /*#__PURE__*/ l.ref<SubjectReviewState>(
      (() => subjectReviewState) as any,
    ),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    priorityScore: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0, maximum: 100 }),
    ),
    muteUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    muteReportingUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastReviewedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'did' }),
    ),
    lastReviewedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastReportedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastAppealedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    takendown: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    appealed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    suspendUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    tags: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    accountStats: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AccountStats>((() => accountStats) as any),
    ),
    recordsStats: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RecordsStats>((() => recordsStats) as any),
    ),
    accountStrike: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AccountStrike>((() => accountStrike) as any),
    ),
    ageAssuranceState: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['pending', 'assured', 'unknown', 'reset', 'blocked']
      }>(),
    ),
    ageAssuranceUpdatedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['admin', 'user'] }>(),
    ),
  }),
)

export { subjectStatusView }

/** Detailed view of a subject. For record subjects, the author's repo and profile will be returned. */
type SubjectView = {
  $type?: 'tools.ozone.moderation.defs#subjectView'
  type: ModerationDefs.SubjectType
  subject: string
  status?: SubjectStatusView
  repo?: RepoViewDetail
  profile?: l.Unknown$TypedObject
  record?: RecordViewDetail
}

export type { SubjectView }

/** Detailed view of a subject. For record subjects, the author's repo and profile will be returned. */
const subjectView = /*#__PURE__*/ l.typedObject<SubjectView>(
  $nsid,
  'subjectView',
  /*#__PURE__*/ l.object({
    type: /*#__PURE__*/ l.ref<ModerationDefs.SubjectType>(
      (() => ModerationDefs.subjectType) as any,
    ),
    subject: /*#__PURE__*/ l.string(),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
    repo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RepoViewDetail>((() => repoViewDetail) as any),
    ),
    profile: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([], false)),
    record: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RecordViewDetail>((() => recordViewDetail) as any),
    ),
  }),
)

export { subjectView }

/** Statistics about a particular account subject */
type AccountStats = {
  $type?: 'tools.ozone.moderation.defs#accountStats'

  /**
   * Total number of reports on the account
   */
  reportCount?: number

  /**
   * Total number of appeals against a moderation action on the account
   */
  appealCount?: number

  /**
   * Number of times the account was suspended
   */
  suspendCount?: number

  /**
   * Number of times the account was escalated
   */
  escalateCount?: number

  /**
   * Number of times the account was taken down
   */
  takedownCount?: number
}

export type { AccountStats }

/** Statistics about a particular account subject */
const accountStats = /*#__PURE__*/ l.typedObject<AccountStats>(
  $nsid,
  'accountStats',
  /*#__PURE__*/ l.object({
    reportCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    appealCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    suspendCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalateCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    takedownCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { accountStats }

/** Statistics about a set of record subject items */
type RecordsStats = {
  $type?: 'tools.ozone.moderation.defs#recordsStats'

  /**
   * Cumulative sum of the number of reports on the items in the set
   */
  totalReports?: number

  /**
   * Number of items that were reported at least once
   */
  reportedCount?: number

  /**
   * Number of items that were escalated at least once
   */
  escalatedCount?: number

  /**
   * Number of items that were appealed at least once
   */
  appealedCount?: number

  /**
   * Total number of item in the set
   */
  subjectCount?: number

  /**
   * Number of item currently in "reviewOpen" or "reviewEscalated" state
   */
  pendingCount?: number

  /**
   * Number of item currently in "reviewNone" or "reviewClosed" state
   */
  processedCount?: number

  /**
   * Number of item currently taken down
   */
  takendownCount?: number
}

export type { RecordsStats }

/** Statistics about a set of record subject items */
const recordsStats = /*#__PURE__*/ l.typedObject<RecordsStats>(
  $nsid,
  'recordsStats',
  /*#__PURE__*/ l.object({
    totalReports: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    reportedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalatedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    appealedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    subjectCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    pendingCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    processedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    takendownCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { recordsStats }

/** Strike information for an account */
type AccountStrike = {
  $type?: 'tools.ozone.moderation.defs#accountStrike'

  /**
   * Current number of active strikes (excluding expired strikes)
   */
  activeStrikeCount?: number

  /**
   * Total number of strikes ever received (including expired strikes)
   */
  totalStrikeCount?: number

  /**
   * Timestamp of the first strike received
   */
  firstStrikeAt?: l.DatetimeString

  /**
   * Timestamp of the most recent strike received
   */
  lastStrikeAt?: l.DatetimeString
}

export type { AccountStrike }

/** Strike information for an account */
const accountStrike = /*#__PURE__*/ l.typedObject<AccountStrike>(
  $nsid,
  'accountStrike',
  /*#__PURE__*/ l.object({
    activeStrikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    totalStrikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    firstStrikeAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastStrikeAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { accountStrike }

type SubjectReviewState =
  | 'tools.ozone.moderation.defs#reviewOpen'
  | 'tools.ozone.moderation.defs#reviewEscalated'
  | 'tools.ozone.moderation.defs#reviewClosed'
  | 'tools.ozone.moderation.defs#reviewNone'
  | l.UnknownString

export type { SubjectReviewState }

const subjectReviewState = /*#__PURE__*/ l.string<{
  knownValues: [
    'tools.ozone.moderation.defs#reviewOpen',
    'tools.ozone.moderation.defs#reviewEscalated',
    'tools.ozone.moderation.defs#reviewClosed',
    'tools.ozone.moderation.defs#reviewNone',
  ]
}>()

export { subjectReviewState }

/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */
type ReviewOpen = 'tools.ozone.moderation.defs#reviewOpen'

export type { ReviewOpen }

/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */
const reviewOpen = /*#__PURE__*/ l.token($nsid, 'reviewOpen')

export { reviewOpen }

/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */
type ReviewEscalated = 'tools.ozone.moderation.defs#reviewEscalated'

export type { ReviewEscalated }

/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */
const reviewEscalated = /*#__PURE__*/ l.token($nsid, 'reviewEscalated')

export { reviewEscalated }

/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */
type ReviewClosed = 'tools.ozone.moderation.defs#reviewClosed'

export type { ReviewClosed }

/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */
const reviewClosed = /*#__PURE__*/ l.token($nsid, 'reviewClosed')

export { reviewClosed }

/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */
type ReviewNone = 'tools.ozone.moderation.defs#reviewNone'

export type { ReviewNone }

/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */
const reviewNone = /*#__PURE__*/ l.token($nsid, 'reviewNone')

export { reviewNone }

/** Take down a subject permanently or temporarily */
type ModEventTakedown = {
  $type?: 'tools.ozone.moderation.defs#modEventTakedown'
  comment?: string

  /**
   * Indicates how long the takedown should be in effect before automatically expiring.
   */
  durationInHours?: number

  /**
   * If true, all other reports on content authored by this account will be resolved (acknowledged).
   */
  acknowledgeAccountSubjects?: boolean

  /**
   * Names/Keywords of the policies that drove the decision.
   */
  policies?: string[]

  /**
   * Severity level of the violation (e.g., 'sev-0', 'sev-1', 'sev-2', etc.).
   */
  severityLevel?: string

  /**
   * List of services where the takedown should be applied. If empty or not provided, takedown is applied on all configured services.
   */
  targetServices?: ('appview' | 'pds' | l.UnknownString)[]

  /**
   * Number of strikes to assign to the user for this violation.
   */
  strikeCount?: number

  /**
   * When the strike should expire. If not provided, the strike never expires.
   */
  strikeExpiresAt?: l.DatetimeString
}

export type { ModEventTakedown }

/** Take down a subject permanently or temporarily */
const modEventTakedown = /*#__PURE__*/ l.typedObject<ModEventTakedown>(
  $nsid,
  'modEventTakedown',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    acknowledgeAccountSubjects: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.boolean(),
    ),
    policies: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 5 }),
    ),
    severityLevel: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    targetServices: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string<{ knownValues: ['appview', 'pds'] }>(),
      ),
    ),
    strikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    strikeExpiresAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { modEventTakedown }

/** Revert take down action on a subject */
type ModEventReverseTakedown = {
  $type?: 'tools.ozone.moderation.defs#modEventReverseTakedown'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string

  /**
   * Names/Keywords of the policy infraction for which takedown is being reversed.
   */
  policies?: string[]

  /**
   * Severity level of the violation. Usually set from the last policy infraction's severity.
   */
  severityLevel?: string

  /**
   * Number of strikes to subtract from the user's strike count. Usually set from the last policy infraction's severity.
   */
  strikeCount?: number
}

export type { ModEventReverseTakedown }

/** Revert take down action on a subject */
const modEventReverseTakedown =
  /*#__PURE__*/ l.typedObject<ModEventReverseTakedown>(
    $nsid,
    'modEventReverseTakedown',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      policies: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 5 }),
      ),
      severityLevel: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      strikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    }),
  )

export { modEventReverseTakedown }

/** Resolve appeal on a subject */
type ModEventResolveAppeal = {
  $type?: 'tools.ozone.moderation.defs#modEventResolveAppeal'

  /**
   * Describe resolution.
   */
  comment?: string
}

export type { ModEventResolveAppeal }

/** Resolve appeal on a subject */
const modEventResolveAppeal =
  /*#__PURE__*/ l.typedObject<ModEventResolveAppeal>(
    $nsid,
    'modEventResolveAppeal',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { modEventResolveAppeal }

/** Add a comment to a subject. An empty comment will clear any previously set sticky comment. */
type ModEventComment = {
  $type?: 'tools.ozone.moderation.defs#modEventComment'
  comment?: string

  /**
   * Make the comment persistent on the subject
   */
  sticky?: boolean
}

export type { ModEventComment }

/** Add a comment to a subject. An empty comment will clear any previously set sticky comment. */
const modEventComment = /*#__PURE__*/ l.typedObject<ModEventComment>(
  $nsid,
  'modEventComment',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    sticky: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  }),
)

export { modEventComment }

/** Report a subject */
type ModEventReport = {
  $type?: 'tools.ozone.moderation.defs#modEventReport'
  comment?: string

  /**
   * Set to true if the reporter was muted from reporting at the time of the event. These reports won't impact the reviewState of the subject.
   */
  isReporterMuted?: boolean
  reportType: ModerationDefs.ReasonType
}

export type { ModEventReport }

/** Report a subject */
const modEventReport = /*#__PURE__*/ l.typedObject<ModEventReport>(
  $nsid,
  'modEventReport',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    isReporterMuted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    reportType: /*#__PURE__*/ l.ref<ModerationDefs.ReasonType>(
      (() => ModerationDefs.reasonType) as any,
    ),
  }),
)

export { modEventReport }

/** Apply/Negate labels on a subject */
type ModEventLabel = {
  $type?: 'tools.ozone.moderation.defs#modEventLabel'
  comment?: string
  createLabelVals: string[]
  negateLabelVals: string[]

  /**
   * Indicates how long the label will remain on the subject. Only applies on labels that are being added.
   */
  durationInHours?: number
}

export type { ModEventLabel }

/** Apply/Negate labels on a subject */
const modEventLabel = /*#__PURE__*/ l.typedObject<ModEventLabel>(
  $nsid,
  'modEventLabel',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    createLabelVals: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    negateLabelVals: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { modEventLabel }

/** Set priority score of the subject. Higher score means higher priority. */
type ModEventPriorityScore = {
  $type?: 'tools.ozone.moderation.defs#modEventPriorityScore'
  comment?: string
  score: number
}

export type { ModEventPriorityScore }

/** Set priority score of the subject. Higher score means higher priority. */
const modEventPriorityScore =
  /*#__PURE__*/ l.typedObject<ModEventPriorityScore>(
    $nsid,
    'modEventPriorityScore',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      score: /*#__PURE__*/ l.integer({ minimum: 0, maximum: 100 }),
    }),
  )

export { modEventPriorityScore }

/** Age assurance info coming directly from users. Only works on DID subjects. */
type AgeAssuranceEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssuranceEvent'

  /**
   * The date and time of this write operation.
   */
  createdAt: l.DatetimeString

  /**
   * The unique identifier for this instance of the age assurance flow, in UUID format.
   */
  attemptId: string

  /**
   * The status of the Age Assurance process.
   */
  status: 'unknown' | 'pending' | 'assured' | l.UnknownString
  access?: AgeassuranceDefs.Access

  /**
   * The ISO 3166-1 alpha-2 country code provided when beginning the Age Assurance flow.
   */
  countryCode?: string

  /**
   * The ISO 3166-2 region code provided when beginning the Age Assurance flow.
   */
  regionCode?: string

  /**
   * The IP address used when initiating the AA flow.
   */
  initIp?: string

  /**
   * The user agent used when initiating the AA flow.
   */
  initUa?: string

  /**
   * The IP address used when completing the AA flow.
   */
  completeIp?: string

  /**
   * The user agent used when completing the AA flow.
   */
  completeUa?: string
}

export type { AgeAssuranceEvent }

/** Age assurance info coming directly from users. Only works on DID subjects. */
const ageAssuranceEvent = /*#__PURE__*/ l.typedObject<AgeAssuranceEvent>(
  $nsid,
  'ageAssuranceEvent',
  /*#__PURE__*/ l.object({
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    attemptId: /*#__PURE__*/ l.string(),
    status: /*#__PURE__*/ l.string<{
      knownValues: ['unknown', 'pending', 'assured']
    }>(),
    access: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AgeassuranceDefs.Access>(
        (() => AgeassuranceDefs.access) as any,
      ),
    ),
    countryCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    regionCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    initIp: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    initUa: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    completeIp: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    completeUa: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { ageAssuranceEvent }

/** Age assurance status override by moderators. Only works on DID subjects. */
type AgeAssuranceOverrideEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssuranceOverrideEvent'

  /**
   * The status to be set for the user decided by a moderator, overriding whatever value the user had previously. Use reset to default to original state.
   */
  status: 'assured' | 'reset' | 'blocked' | l.UnknownString
  access?: AgeassuranceDefs.Access

  /**
   * Comment describing the reason for the override.
   */
  comment: string
}

export type { AgeAssuranceOverrideEvent }

/** Age assurance status override by moderators. Only works on DID subjects. */
const ageAssuranceOverrideEvent =
  /*#__PURE__*/ l.typedObject<AgeAssuranceOverrideEvent>(
    $nsid,
    'ageAssuranceOverrideEvent',
    /*#__PURE__*/ l.object({
      status: /*#__PURE__*/ l.string<{
        knownValues: ['assured', 'reset', 'blocked']
      }>(),
      access: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.ref<AgeassuranceDefs.Access>(
          (() => AgeassuranceDefs.access) as any,
        ),
      ),
      comment: /*#__PURE__*/ l.string({ minLength: 1 }),
    }),
  )

export { ageAssuranceOverrideEvent }

/** Purges all age assurance events for the subject. Only works on DID subjects. Moderator-only. */
type AgeAssurancePurgeEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssurancePurgeEvent'

  /**
   * Comment describing the reason for the purge.
   */
  comment: string
}

export type { AgeAssurancePurgeEvent }

/** Purges all age assurance events for the subject. Only works on DID subjects. Moderator-only. */
const ageAssurancePurgeEvent =
  /*#__PURE__*/ l.typedObject<AgeAssurancePurgeEvent>(
    $nsid,
    'ageAssurancePurgeEvent',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.string({ minLength: 1 }),
    }),
  )

export { ageAssurancePurgeEvent }

/** Account credentials revocation by moderators. Only works on DID subjects. */
type RevokeAccountCredentialsEvent = {
  $type?: 'tools.ozone.moderation.defs#revokeAccountCredentialsEvent'

  /**
   * Comment describing the reason for the revocation.
   */
  comment: string
}

export type { RevokeAccountCredentialsEvent }

/** Account credentials revocation by moderators. Only works on DID subjects. */
const revokeAccountCredentialsEvent =
  /*#__PURE__*/ l.typedObject<RevokeAccountCredentialsEvent>(
    $nsid,
    'revokeAccountCredentialsEvent',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.string({ minLength: 1 }),
    }),
  )

export { revokeAccountCredentialsEvent }

type ModEventAcknowledge = {
  $type?: 'tools.ozone.moderation.defs#modEventAcknowledge'
  comment?: string

  /**
   * If true, all other reports on content authored by this account will be resolved (acknowledged).
   */
  acknowledgeAccountSubjects?: boolean
}

export type { ModEventAcknowledge }

const modEventAcknowledge = /*#__PURE__*/ l.typedObject<ModEventAcknowledge>(
  $nsid,
  'modEventAcknowledge',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    acknowledgeAccountSubjects: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.boolean(),
    ),
  }),
)

export { modEventAcknowledge }

type ModEventEscalate = {
  $type?: 'tools.ozone.moderation.defs#modEventEscalate'
  comment?: string
}

export type { ModEventEscalate }

const modEventEscalate = /*#__PURE__*/ l.typedObject<ModEventEscalate>(
  $nsid,
  'modEventEscalate',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { modEventEscalate }

/** Mute incoming reports on a subject */
type ModEventMute = {
  $type?: 'tools.ozone.moderation.defs#modEventMute'
  comment?: string

  /**
   * Indicates how long the subject should remain muted.
   */
  durationInHours: number
}

export type { ModEventMute }

/** Mute incoming reports on a subject */
const modEventMute = /*#__PURE__*/ l.typedObject<ModEventMute>(
  $nsid,
  'modEventMute',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.integer(),
  }),
)

export { modEventMute }

/** Unmute action on a subject */
type ModEventUnmute = {
  $type?: 'tools.ozone.moderation.defs#modEventUnmute'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string
}

export type { ModEventUnmute }

/** Unmute action on a subject */
const modEventUnmute = /*#__PURE__*/ l.typedObject<ModEventUnmute>(
  $nsid,
  'modEventUnmute',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { modEventUnmute }

/** Mute incoming reports from an account */
type ModEventMuteReporter = {
  $type?: 'tools.ozone.moderation.defs#modEventMuteReporter'
  comment?: string

  /**
   * Indicates how long the account should remain muted. Falsy value here means a permanent mute.
   */
  durationInHours?: number
}

export type { ModEventMuteReporter }

/** Mute incoming reports from an account */
const modEventMuteReporter = /*#__PURE__*/ l.typedObject<ModEventMuteReporter>(
  $nsid,
  'modEventMuteReporter',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { modEventMuteReporter }

/** Unmute incoming reports from an account */
type ModEventUnmuteReporter = {
  $type?: 'tools.ozone.moderation.defs#modEventUnmuteReporter'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string
}

export type { ModEventUnmuteReporter }

/** Unmute incoming reports from an account */
const modEventUnmuteReporter =
  /*#__PURE__*/ l.typedObject<ModEventUnmuteReporter>(
    $nsid,
    'modEventUnmuteReporter',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { modEventUnmuteReporter }

/** Keep a log of outgoing email to a user */
type ModEventEmail = {
  $type?: 'tools.ozone.moderation.defs#modEventEmail'

  /**
   * The subject line of the email sent to the user.
   */
  subjectLine: string

  /**
   * The content of the email sent to the user.
   */
  content?: string

  /**
   * Additional comment about the outgoing comm.
   */
  comment?: string

  /**
   * Names/Keywords of the policies that necessitated the email.
   */
  policies?: string[]

  /**
   * Severity level of the violation. Normally 'sev-1' that adds strike on repeat offense
   */
  severityLevel?: string

  /**
   * Number of strikes to assign to the user for this violation. Normally 0 as an indicator of a warning and only added as a strike on a repeat offense.
   */
  strikeCount?: number

  /**
   * When the strike should expire. If not provided, the strike never expires.
   */
  strikeExpiresAt?: l.DatetimeString

  /**
   * Indicates whether the email was successfully delivered to the user's inbox.
   */
  isDelivered?: boolean
}

export type { ModEventEmail }

/** Keep a log of outgoing email to a user */
const modEventEmail = /*#__PURE__*/ l.typedObject<ModEventEmail>(
  $nsid,
  'modEventEmail',
  /*#__PURE__*/ l.object({
    subjectLine: /*#__PURE__*/ l.string(),
    content: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    policies: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 5 }),
    ),
    severityLevel: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    strikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    strikeExpiresAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    isDelivered: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  }),
)

export { modEventEmail }

/** Divert a record's blobs to a 3rd party service for further scanning/tagging */
type ModEventDivert = {
  $type?: 'tools.ozone.moderation.defs#modEventDivert'
  comment?: string
}

export type { ModEventDivert }

/** Divert a record's blobs to a 3rd party service for further scanning/tagging */
const modEventDivert = /*#__PURE__*/ l.typedObject<ModEventDivert>(
  $nsid,
  'modEventDivert',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { modEventDivert }

/** Add/Remove a tag on a subject */
type ModEventTag = {
  $type?: 'tools.ozone.moderation.defs#modEventTag'

  /**
   * Tags to be added to the subject. If already exists, won't be duplicated.
   */
  add: string[]

  /**
   * Tags to be removed to the subject. Ignores a tag If it doesn't exist, won't be duplicated.
   */
  remove: string[]

  /**
   * Additional comment about added/removed tags.
   */
  comment?: string

  /**
   * Indicates how long the tags being added should remain before automatically being removed. Only applies to tags being added.
   */
  durationInHours?: number
}

export type { ModEventTag }

/** Add/Remove a tag on a subject */
const modEventTag = /*#__PURE__*/ l.typedObject<ModEventTag>(
  $nsid,
  'modEventTag',
  /*#__PURE__*/ l.object({
    add: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    remove: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { modEventTag }

/** Logs account status related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type AccountEvent = {
  $type?: 'tools.ozone.moderation.defs#accountEvent'
  comment?: string

  /**
   * Indicates that the account has a repository which can be fetched from the host that emitted this event.
   */
  active: boolean
  status?:
    | 'unknown'
    | 'deactivated'
    | 'deleted'
    | 'takendown'
    | 'suspended'
    | 'tombstoned'
    | l.UnknownString
  timestamp: l.DatetimeString
}

export type { AccountEvent }

/** Logs account status related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const accountEvent = /*#__PURE__*/ l.typedObject<AccountEvent>(
  $nsid,
  'accountEvent',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    active: /*#__PURE__*/ l.boolean(),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'unknown',
          'deactivated',
          'deleted',
          'takendown',
          'suspended',
          'tombstoned',
        ]
      }>(),
    ),
    timestamp: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { accountEvent }

/** Logs identity related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type IdentityEvent = {
  $type?: 'tools.ozone.moderation.defs#identityEvent'
  comment?: string
  handle?: l.HandleString
  pdsHost?: l.UriString
  tombstone?: boolean
  timestamp: l.DatetimeString
}

export type { IdentityEvent }

/** Logs identity related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const identityEvent = /*#__PURE__*/ l.typedObject<IdentityEvent>(
  $nsid,
  'identityEvent',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    handle: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'handle' }),
    ),
    pdsHost: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri' }),
    ),
    tombstone: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    timestamp: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { identityEvent }

/** Logs lifecycle event on a record subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type RecordEvent = {
  $type?: 'tools.ozone.moderation.defs#recordEvent'
  comment?: string
  op: 'create' | 'update' | 'delete' | l.UnknownString
  cid?: l.CidString
  timestamp: l.DatetimeString
}

export type { RecordEvent }

/** Logs lifecycle event on a record subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const recordEvent = /*#__PURE__*/ l.typedObject<RecordEvent>(
  $nsid,
  'recordEvent',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    op: /*#__PURE__*/ l.string<{
      knownValues: ['create', 'update', 'delete']
    }>(),
    cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
    timestamp: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { recordEvent }

/** Logs a scheduled takedown action for an account. */
type ScheduleTakedownEvent = {
  $type?: 'tools.ozone.moderation.defs#scheduleTakedownEvent'
  comment?: string
  executeAt?: l.DatetimeString
  executeAfter?: l.DatetimeString
  executeUntil?: l.DatetimeString
}

export type { ScheduleTakedownEvent }

/** Logs a scheduled takedown action for an account. */
const scheduleTakedownEvent =
  /*#__PURE__*/ l.typedObject<ScheduleTakedownEvent>(
    $nsid,
    'scheduleTakedownEvent',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      executeAt: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string({ format: 'datetime' }),
      ),
      executeAfter: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string({ format: 'datetime' }),
      ),
      executeUntil: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string({ format: 'datetime' }),
      ),
    }),
  )

export { scheduleTakedownEvent }

/** Logs cancellation of a scheduled takedown action for an account. */
type CancelScheduledTakedownEvent = {
  $type?: 'tools.ozone.moderation.defs#cancelScheduledTakedownEvent'
  comment?: string
}

export type { CancelScheduledTakedownEvent }

/** Logs cancellation of a scheduled takedown action for an account. */
const cancelScheduledTakedownEvent =
  /*#__PURE__*/ l.typedObject<CancelScheduledTakedownEvent>(
    $nsid,
    'cancelScheduledTakedownEvent',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { cancelScheduledTakedownEvent }

type RepoView = {
  $type?: 'tools.ozone.moderation.defs#repoView'
  did: l.DidString
  handle: l.HandleString
  email?: string
  relatedRecords: l.LexMap[]
  indexedAt: l.DatetimeString
  moderation: Moderation
  invitedBy?: ServerDefs.InviteCode
  invitesDisabled?: boolean
  inviteNote?: string
  deactivatedAt?: l.DatetimeString
  threatSignatures?: AdminDefs.ThreatSignature[]
}

export type { RepoView }

const repoView = /*#__PURE__*/ l.typedObject<RepoView>(
  $nsid,
  'repoView',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    relatedRecords: /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    moderation: /*#__PURE__*/ l.ref<Moderation>((() => moderation) as any),
    invitedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
        (() => ServerDefs.inviteCode) as any,
      ),
    ),
    invitesDisabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    inviteNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    deactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    threatSignatures: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<AdminDefs.ThreatSignature>(
          (() => AdminDefs.threatSignature) as any,
        ),
      ),
    ),
  }),
)

export { repoView }

type RepoViewDetail = {
  $type?: 'tools.ozone.moderation.defs#repoViewDetail'
  did: l.DidString
  handle: l.HandleString
  email?: string
  relatedRecords: l.LexMap[]
  indexedAt: l.DatetimeString
  moderation: ModerationDetail
  labels?: LabelDefs.Label[]
  invitedBy?: ServerDefs.InviteCode
  invites?: ServerDefs.InviteCode[]
  invitesDisabled?: boolean
  inviteNote?: string
  emailConfirmedAt?: l.DatetimeString
  deactivatedAt?: l.DatetimeString
  threatSignatures?: AdminDefs.ThreatSignature[]
}

export type { RepoViewDetail }

const repoViewDetail = /*#__PURE__*/ l.typedObject<RepoViewDetail>(
  $nsid,
  'repoViewDetail',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    relatedRecords: /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    moderation: /*#__PURE__*/ l.ref<ModerationDetail>(
      (() => moderationDetail) as any,
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    invitedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
        (() => ServerDefs.inviteCode) as any,
      ),
    ),
    invites: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
          (() => ServerDefs.inviteCode) as any,
        ),
      ),
    ),
    invitesDisabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    inviteNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    emailConfirmedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    deactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    threatSignatures: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<AdminDefs.ThreatSignature>(
          (() => AdminDefs.threatSignature) as any,
        ),
      ),
    ),
  }),
)

export { repoViewDetail }

type RepoViewNotFound = {
  $type?: 'tools.ozone.moderation.defs#repoViewNotFound'
  did: l.DidString
}

export type { RepoViewNotFound }

const repoViewNotFound = /*#__PURE__*/ l.typedObject<RepoViewNotFound>(
  $nsid,
  'repoViewNotFound',
  /*#__PURE__*/ l.object({ did: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { repoViewNotFound }

type RecordView = {
  $type?: 'tools.ozone.moderation.defs#recordView'
  uri: l.AtUriString
  cid: l.CidString
  value: l.LexMap
  blobCids: l.CidString[]
  indexedAt: l.DatetimeString
  moderation: Moderation
  repo: RepoView
}

export type { RecordView }

const recordView = /*#__PURE__*/ l.typedObject<RecordView>(
  $nsid,
  'recordView',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    value: /*#__PURE__*/ l.lexMap(),
    blobCids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'cid' })),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    moderation: /*#__PURE__*/ l.ref<Moderation>((() => moderation) as any),
    repo: /*#__PURE__*/ l.ref<RepoView>((() => repoView) as any),
  }),
)

export { recordView }

type RecordViewDetail = {
  $type?: 'tools.ozone.moderation.defs#recordViewDetail'
  uri: l.AtUriString
  cid: l.CidString
  value: l.LexMap
  blobs: BlobView[]
  labels?: LabelDefs.Label[]
  indexedAt: l.DatetimeString
  moderation: ModerationDetail
  repo: RepoView
}

export type { RecordViewDetail }

const recordViewDetail = /*#__PURE__*/ l.typedObject<RecordViewDetail>(
  $nsid,
  'recordViewDetail',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    value: /*#__PURE__*/ l.lexMap(),
    blobs: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<BlobView>((() => blobView) as any),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    moderation: /*#__PURE__*/ l.ref<ModerationDetail>(
      (() => moderationDetail) as any,
    ),
    repo: /*#__PURE__*/ l.ref<RepoView>((() => repoView) as any),
  }),
)

export { recordViewDetail }

type RecordViewNotFound = {
  $type?: 'tools.ozone.moderation.defs#recordViewNotFound'
  uri: l.AtUriString
}

export type { RecordViewNotFound }

const recordViewNotFound = /*#__PURE__*/ l.typedObject<RecordViewNotFound>(
  $nsid,
  'recordViewNotFound',
  /*#__PURE__*/ l.object({ uri: /*#__PURE__*/ l.string({ format: 'at-uri' }) }),
)

export { recordViewNotFound }

type Moderation = {
  $type?: 'tools.ozone.moderation.defs#moderation'
  subjectStatus?: SubjectStatusView
}

export type { Moderation }

const moderation = /*#__PURE__*/ l.typedObject<Moderation>(
  $nsid,
  'moderation',
  /*#__PURE__*/ l.object({
    subjectStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
  }),
)

export { moderation }

type ModerationDetail = {
  $type?: 'tools.ozone.moderation.defs#moderationDetail'
  subjectStatus?: SubjectStatusView
}

export type { ModerationDetail }

const moderationDetail = /*#__PURE__*/ l.typedObject<ModerationDetail>(
  $nsid,
  'moderationDetail',
  /*#__PURE__*/ l.object({
    subjectStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
  }),
)

export { moderationDetail }

type BlobView = {
  $type?: 'tools.ozone.moderation.defs#blobView'
  cid: l.CidString
  mimeType: string
  size: number
  createdAt: l.DatetimeString
  details?:
    | l.$Typed<ImageDetails>
    | l.$Typed<VideoDetails>
    | l.Unknown$TypedObject
  moderation?: Moderation
}

export type { BlobView }

const blobView = /*#__PURE__*/ l.typedObject<BlobView>(
  $nsid,
  'blobView',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    mimeType: /*#__PURE__*/ l.string(),
    size: /*#__PURE__*/ l.integer(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    details: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<ImageDetails>((() => imageDetails) as any),
          /*#__PURE__*/ l.typedRef<VideoDetails>((() => videoDetails) as any),
        ],
        false,
      ),
    ),
    moderation: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<Moderation>((() => moderation) as any),
    ),
  }),
)

export { blobView }

type ImageDetails = {
  $type?: 'tools.ozone.moderation.defs#imageDetails'
  width: number
  height: number
}

export type { ImageDetails }

const imageDetails = /*#__PURE__*/ l.typedObject<ImageDetails>(
  $nsid,
  'imageDetails',
  /*#__PURE__*/ l.object({
    width: /*#__PURE__*/ l.integer(),
    height: /*#__PURE__*/ l.integer(),
  }),
)

export { imageDetails }

type VideoDetails = {
  $type?: 'tools.ozone.moderation.defs#videoDetails'
  width: number
  height: number
  length: number
}

export type { VideoDetails }

const videoDetails = /*#__PURE__*/ l.typedObject<VideoDetails>(
  $nsid,
  'videoDetails',
  /*#__PURE__*/ l.object({
    width: /*#__PURE__*/ l.integer(),
    height: /*#__PURE__*/ l.integer(),
    length: /*#__PURE__*/ l.integer(),
  }),
)

export { videoDetails }

type AccountHosting = {
  $type?: 'tools.ozone.moderation.defs#accountHosting'
  status:
    | 'takendown'
    | 'suspended'
    | 'deleted'
    | 'deactivated'
    | 'unknown'
    | l.UnknownString
  updatedAt?: l.DatetimeString
  createdAt?: l.DatetimeString
  deletedAt?: l.DatetimeString
  deactivatedAt?: l.DatetimeString
  reactivatedAt?: l.DatetimeString
}

export type { AccountHosting }

const accountHosting = /*#__PURE__*/ l.typedObject<AccountHosting>(
  $nsid,
  'accountHosting',
  /*#__PURE__*/ l.object({
    status: /*#__PURE__*/ l.string<{
      knownValues: [
        'takendown',
        'suspended',
        'deleted',
        'deactivated',
        'unknown',
      ]
    }>(),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    deletedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    deactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    reactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { accountHosting }

type RecordHosting = {
  $type?: 'tools.ozone.moderation.defs#recordHosting'
  status: 'deleted' | 'unknown' | l.UnknownString
  updatedAt?: l.DatetimeString
  createdAt?: l.DatetimeString
  deletedAt?: l.DatetimeString
}

export type { RecordHosting }

const recordHosting = /*#__PURE__*/ l.typedObject<RecordHosting>(
  $nsid,
  'recordHosting',
  /*#__PURE__*/ l.object({
    status: /*#__PURE__*/ l.string<{ knownValues: ['deleted', 'unknown'] }>(),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    deletedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { recordHosting }

type ReporterStats = {
  $type?: 'tools.ozone.moderation.defs#reporterStats'
  did: l.DidString

  /**
   * The total number of reports made by the user on accounts.
   */
  accountReportCount: number

  /**
   * The total number of reports made by the user on records.
   */
  recordReportCount: number

  /**
   * The total number of accounts reported by the user.
   */
  reportedAccountCount: number

  /**
   * The total number of records reported by the user.
   */
  reportedRecordCount: number

  /**
   * The total number of accounts taken down as a result of the user's reports.
   */
  takendownAccountCount: number

  /**
   * The total number of records taken down as a result of the user's reports.
   */
  takendownRecordCount: number

  /**
   * The total number of accounts labeled as a result of the user's reports.
   */
  labeledAccountCount: number

  /**
   * The total number of records labeled as a result of the user's reports.
   */
  labeledRecordCount: number
}

export type { ReporterStats }

const reporterStats = /*#__PURE__*/ l.typedObject<ReporterStats>(
  $nsid,
  'reporterStats',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    accountReportCount: /*#__PURE__*/ l.integer(),
    recordReportCount: /*#__PURE__*/ l.integer(),
    reportedAccountCount: /*#__PURE__*/ l.integer(),
    reportedRecordCount: /*#__PURE__*/ l.integer(),
    takendownAccountCount: /*#__PURE__*/ l.integer(),
    takendownRecordCount: /*#__PURE__*/ l.integer(),
    labeledAccountCount: /*#__PURE__*/ l.integer(),
    labeledRecordCount: /*#__PURE__*/ l.integer(),
  }),
)

export { reporterStats }

/** Moderation tool information for tracing the source of the action */
type ModTool = {
  $type?: 'tools.ozone.moderation.defs#modTool'

  /**
   * Name/identifier of the source (e.g., 'automod', 'ozone/workspace')
   */
  name: string

  /**
   * Additional arbitrary metadata about the source
   */
  meta?: l.LexMap
}

export type { ModTool }

/** Moderation tool information for tracing the source of the action */
const modTool = /*#__PURE__*/ l.typedObject<ModTool>(
  $nsid,
  'modTool',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string(),
    meta: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
  }),
)

export { modTool }

/** Moderation event timeline event for a PLC create operation */
type TimelineEventPlcCreate =
  'tools.ozone.moderation.defs#timelineEventPlcCreate'

export type { TimelineEventPlcCreate }

/** Moderation event timeline event for a PLC create operation */
const timelineEventPlcCreate = /*#__PURE__*/ l.token(
  $nsid,
  'timelineEventPlcCreate',
)

export { timelineEventPlcCreate }

/** Moderation event timeline event for generic PLC operation */
type TimelineEventPlcOperation =
  'tools.ozone.moderation.defs#timelineEventPlcOperation'

export type { TimelineEventPlcOperation }

/** Moderation event timeline event for generic PLC operation */
const timelineEventPlcOperation = /*#__PURE__*/ l.token(
  $nsid,
  'timelineEventPlcOperation',
)

export { timelineEventPlcOperation }

/** Moderation event timeline event for a PLC tombstone operation */
type TimelineEventPlcTombstone =
  'tools.ozone.moderation.defs#timelineEventPlcTombstone'

export type { TimelineEventPlcTombstone }

/** Moderation event timeline event for a PLC tombstone operation */
const timelineEventPlcTombstone = /*#__PURE__*/ l.token(
  $nsid,
  'timelineEventPlcTombstone',
)

export { timelineEventPlcTombstone }

/** View of a scheduled moderation action */
type ScheduledActionView = {
  $type?: 'tools.ozone.moderation.defs#scheduledActionView'

  /**
   * Auto-incrementing row ID
   */
  id: number

  /**
   * Type of action to be executed
   */
  action: 'takedown' | l.UnknownString

  /**
   * Serialized event object that will be propagated to the event when performed
   */
  eventData?: l.LexMap

  /**
   * Subject DID for the action
   */
  did: l.DidString

  /**
   * Exact time to execute the action
   */
  executeAt?: l.DatetimeString

  /**
   * Earliest time to execute the action (for randomized scheduling)
   */
  executeAfter?: l.DatetimeString

  /**
   * Latest time to execute the action (for randomized scheduling)
   */
  executeUntil?: l.DatetimeString

  /**
   * Whether execution time should be randomized within the specified range
   */
  randomizeExecution?: boolean

  /**
   * DID of the user who created this scheduled action
   */
  createdBy: l.DidString

  /**
   * When the scheduled action was created
   */
  createdAt: l.DatetimeString

  /**
   * When the scheduled action was last updated
   */
  updatedAt?: l.DatetimeString

  /**
   * Current status of the scheduled action
   */
  status: 'pending' | 'executed' | 'cancelled' | 'failed' | l.UnknownString

  /**
   * When the action was last attempted to be executed
   */
  lastExecutedAt?: l.DatetimeString

  /**
   * Reason for the last execution failure
   */
  lastFailureReason?: string

  /**
   * ID of the moderation event created when action was successfully executed
   */
  executionEventId?: number
}

export type { ScheduledActionView }

/** View of a scheduled moderation action */
const scheduledActionView = /*#__PURE__*/ l.typedObject<ScheduledActionView>(
  $nsid,
  'scheduledActionView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    action: /*#__PURE__*/ l.string<{ knownValues: ['takedown'] }>(),
    eventData: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    executeAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    executeAfter: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    executeUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    randomizeExecution: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    status: /*#__PURE__*/ l.string<{
      knownValues: ['pending', 'executed', 'cancelled', 'failed']
    }>(),
    lastExecutedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastFailureReason: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    executionEventId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { scheduledActionView }
